/**
 * @fileoverview Navigation helpers
 */

var $ = require('jquery');
require('bootstrap/js/collapse');
require('bootstrap/js/transition');

function secondaryNav() {
  var SECONDARY = '.inertia-secondary-nav';
  var $selector = $('.inertia-nav-search');
  var targetEl = $(SECONDARY);

  $selector.click(function (e) {
    var $this = $(this);
    var $body = $('body');

    function handleBodyClick (e) {
      if ($(e.target).parents(SECONDARY).length === 0) {
        targetEl.removeClass('active');
        $body.off('click', handleBodyClick);
      }
    }

    targetEl.addClass('active');
    $body.on('click', handleBodyClick);
    return false;
  });
}

module.exports = {
  secondaryNav: secondaryNav
};
